export const CODE_RESEND_DELAY_IN_SECONDS = 60;
